import React from 'react';
import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import Tab from 'components/Tab';
import { SCATTER_PLOT_TYPES } from 'mobx-store/linearModel';

const RightPaneComponent = observer(
  props => {
    const {
      isNumericalCategorical,
      renderResidualsScatterPlot,
      renderProbabilityScatterPlot,
      renderMainScatterPlotOrBoxPlot
    } = props;

    const firstNameItem = () =>
      isNumericalCategorical
        ? 'Levels Box Plot'
        : 'Main Scatter Plot';

    const onFirstMenuItemClick = () => {
      if (!isNumericalCategorical) {
        linearModel.visibleScatterPlotType = SCATTER_PLOT_TYPES.MAIN;
      }
    };

    const onResidualsMenuItemClick = () => {
      linearModel.visibleScatterPlotType = SCATTER_PLOT_TYPES.RESIDUALS;
    };

    const onProbabilityMenuItemClick = () => {
      linearModel.visibleScatterPlotType = SCATTER_PLOT_TYPES.NORMAL;
    };

    const getPanes = () => {
      return [
        {
          renderMenuItem: firstNameItem,
          onMenuItemClick: onFirstMenuItemClick,
          renderPane: renderMainScatterPlotOrBoxPlot
        },
        {
          renderMenuItem: () => 'Scatter Plot of Residuals',
          onMenuItemClick: onResidualsMenuItemClick,
          renderPane: renderResidualsScatterPlot
        },
        {
          renderMenuItem: () => 'Probability Plot of Residuals',
          onMenuItemClick: onProbabilityMenuItemClick,
          renderPane: renderProbabilityScatterPlot
        }
      ];
    };

    return (
      <div id="right-pane">
        <div className="content-item">
          <div className="flex space-between mb-30">
            <Tab
              panes={getPanes()}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default RightPaneComponent;
